export default "__VITE_ASSET__CWAsU3Io__"